import { Descriptions, Tag } from "antd";
import React from "react";

interface TransactionStateTagProps {
  approved: any;
  irc: any;
  style?: React.CSSProperties;
}

const TransactionStateTag: React.FC<TransactionStateTagProps> = ({ approved, irc, style }) => {
  const isApproved = approved || irc === '8444';

  return (
    <Tag color={isApproved ? 'green' : 'red'} style={style}>
      {isApproved ? 'Aprobada' : 'Rechazada'}
    </Tag>
  );
};

export default TransactionStateTag